/*
  Casa Capaldi – zoekvenster in de header (fase 2).
  Opent vanuit het vergrootglas (ook in de meeschuivende header), zet de focus in het zoekveld
  en sluit met de sluitknop, de achtergrond of Escape. De zoekresultaten komen uit de
  bestaande predictive search van het thema (component-predictive-search.js).
*/
(() => {
  let dialog = null;
  let opener = null;

  const isOpen = () => Boolean(dialog && !dialog.hidden);

  const setExpanded = (value) => {
    document.querySelectorAll('[data-cc-search-open]').forEach((btn) => {
      btn.setAttribute('aria-expanded', value);
    });
  };

  const setInert = (on) => {
    (window.inertElems || []).forEach((el) => {
      if (on) {
        el.setAttribute('inert', '');
      } else {
        el.removeAttribute('inert');
      }
    });
  };

  const open = (trigger) => {
    if (!dialog || isOpen()) return;
    opener = trigger || null;
    dialog.hidden = false;
    document.body.classList.add('cc-search-open');
    setExpanded('true');
    setInert(true);
    // Direct focussen binnen de klik, zodat het toetsenbord op iPhone en Android opent.
    const input = dialog.querySelector('input[type="search"]');
    if (input) input.focus();
    requestAnimationFrame(() => dialog.classList.add('cc-search--visible'));
  };

  const close = () => {
    if (!isOpen()) return;
    dialog.classList.remove('cc-search--visible');
    dialog.hidden = true;
    document.body.classList.remove('cc-search-open');
    setExpanded('false');
    setInert(false);
    if (opener && document.contains(opener)) opener.focus();
    opener = null;
  };

  // Eén exemplaar direct onder <body>, zodat het venster boven de meeschuivende header ligt.
  const mount = () => {
    const found = document.getElementById('cc-search');
    if (!found) return;
    document.querySelectorAll('body > .cc-search').forEach((el) => {
      if (el !== found) el.remove();
    });
    if (found.parentElement !== document.body) document.body.appendChild(found);
    dialog = found;
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-cc-search-open]');
    if (trigger) {
      event.preventDefault();
      if (isOpen()) {
        close();
      } else {
        open(trigger);
      }
      return;
    }
    if (isOpen() && event.target.closest('[data-cc-search-close]')) {
      event.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (!isOpen()) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusables = Array.from(
      dialog.querySelectorAll('input:not([type="hidden"]), button:not([tabindex="-1"]), a[href]:not([tabindex="-1"])')
    ).filter((el) => !el.disabled && el.getClientRects().length > 0);
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (!dialog.contains(document.activeElement)) {
      event.preventDefault();
      first.focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  // Het venster is voor mobiel en tablet; sluit het als het scherm breder wordt.
  const desktop = window.matchMedia('(min-width: 1024px)');
  const onChange = (event) => {
    if (event.matches) close();
  };
  if (desktop.addEventListener) {
    desktop.addEventListener('change', onChange);
  } else if (desktop.addListener) {
    desktop.addListener(onChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
  document.addEventListener('shopify:section:load', () => {
    close();
    mount();
  });
})();